import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { styled } from '@mui/material/styles';
import {
  DialogProps,
  Divider,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { t } from 'i18next';
import dayjs, { Dayjs } from 'dayjs';
import { AppContext } from '../../context/AppContext';
import {
  STATUS_ALL_ARRAY,
  MESSAGE_STATUS_ARRAY,
} from '../../constants/Constants';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
// import { fetchCategories } from '../../redux_store/slices/categorySlice';
import {
  getProfile,
  getProfileState,
} from '../../redux_store/slices/GetUserProfileSlice';
import { fetchProducts } from '../../redux_store/slices/productsSlice';
import { storesState, fetchStores } from '../../redux_store/slices/storesSlice';
import {
  fetchSuppliers,
  suppliersState,
} from '../../redux_store/slices/suppliersSlice';
import { formatDateTime } from '../../utils/DateUtils';
import BakeasyCheckbox from '../common/BakeasyCheckbox';
import BakeasyDatePicker from '../common/BakeasyDatePicker';
import { BakeasyButton } from '../buttons/BakeasyButton';
import {
  BakeasySelectAutoCompleteStates,
  BakeasySelectAutoCompleteCities,
  BakeasySelectAutoCompleteZipcode,
  BakeasySelectAutoCompleteMessageFrom,
  BakeasySelectAutoCompleteMessageTo,
} from '../dropdowns/BakeasySelectAutoComplete';
import { BakeasyFilterHeaderLabel } from '../labels/BakeasyHeaderLabel';
import * as TextField from '../textfields/BakeasyTextFields';
import * as Dropdown from '../dropdowns/BakeasySelect';
import { BakeasyAutoCompleteMessagesTo } from '../dropdowns/BakeasyAutoComplete';
import { useSelector } from 'react-redux';
import {
  fetchNewMessageCount,
  getNamesList,
  messagesState,
} from '../../redux_store/slices/messagesSlice';
import { validateField } from '../../utils/ValidationUtils';
import {
  dropdownDataState,
  fetchDropdownData,
} from '../../redux_store/slices/dropdownDataSlice';
import { GRAY_500 } from '../../constants/Colors';

export interface BakeasyConfirmDialogProps {
  dialog?: BakeasyConfirmDialogProp;
}

export interface BakeasyConfirmDialogProp {
  type?: string;
  open?: boolean;
  title?: string;
  message?: string | any;
  data?: any;
  content?: any;
  onYesClick?: (
    event: React.MouseEvent<HTMLButtonElement>,
    param?: any
  ) => void;
  onNoClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': { padding: theme.spacing(2) },
  '& .MuiDialogActions-root': { padding: theme.spacing(1) },
}));

export default function BakeasyConfirmDialog(props: BakeasyConfirmDialogProps) {
  const dispatch = useAppDispatch();
  let myContext = React.useContext(AppContext);

  const [maxWidth, setMaxWidth] = React.useState<DialogProps['maxWidth']>('sm');
  const [text, setText] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [selectedStore, setSelectedStore] = useState<any>('');
  const [selectedName, setSelectName] = useState<any>(undefined);
  const [toAllSuppliers, setToAllSuppliers] = useState<any>(false);
  const [selectSubject, setSelectSubject] = useState<any>('');
  const [selectedPriority, setSelectedPriority] = useState<any>('');
  const [checkedPriority, setCheckedPriority] = useState<any>('normal');
  const [selectContent, setSelectContent] = useState<any>('');
  const [selectProducts, setSelectProducts] = useState<any>('');
  const [selectedStatus, setSelectedStatus] = useState<any>('');
  const [selectedLanguage, setSelectedLanguage] = React.useState('');
  const [selectedMessageStatus, setSelectedMessageStatus] = useState<any>('');
  const [selectedState, setSelectedState] = useState<any>('');
  const [selectedCity, setSelectedCity] = useState<any>(undefined);
  const [zipCode, setZipCode] = useState<any>('');

  const [createdFromDate, setCreatedFromDate] = useState<Dayjs | null>(null);
  const [createdToDate, setCreatedToDate] = useState<Dayjs | null>(null);

  const [lastAccessFromDate, setLastAccessFromDate] = useState<Dayjs | null>(
    null
  );
  const [lastAccessToDate, setLastAccessToDate] = useState<Dayjs | null>(null);
  const [selectedMessageFrom, setSelectedMessageFrom] = useState<any>();
  const [selectedMessageTo, setSelectedMessageTo] = useState<any>();

  let _storeState = useAppSelector(storesState);
  let _supplierState = useAppSelector(suppliersState);
  let _messagesState = useAppSelector(messagesState);
  let _userProfile: any = useAppSelector(getProfileState);
  let _dropdownDataState = useAppSelector(dropdownDataState);

  const auth = useSelector((x: any) => x?.auth?.value);

  React.useEffect(() => {
    setSelectedLanguage(_userProfile?.value?.defaultLanguage);
  }, [_userProfile.value]);

  useEffect(() => {
    if (auth === undefined) {
      return;
    }

    dispatch(fetchNewMessageCount(''));

    // dispatch(fetchCategories({ page: 1, limit: 5 }));
    //dispatch(fetchStates({ page: 1, limit: 5 }));

    dispatch(fetchProducts({ page: 1, limit: 10 }));
    dispatch(fetchStores({ page: 1, limit: 10 }));

    if (_userProfile?.value === undefined) {
      dispatch(getProfile(''));
    } else {
      setSelectedLanguage(_userProfile?.value?.defaultLanguage);
    }

    if (_dropdownDataState?.value?.data?.PaymentMethod.length === 0) {
      dispatch(fetchDropdownData());
    }

    if (_supplierState?.value?.data.length === 0) {
      dispatch(fetchSuppliers({ page: 1, limit: 10 }));
    }
  }, []);

  useEffect(() => {
    props?.dialog?.data?.createdFromDate &&
      setCreatedFromDate(dayjs(props?.dialog?.data?.createdFromDate));
    props?.dialog?.data?.createdToDate &&
      setCreatedToDate(dayjs(props?.dialog?.data?.createdToDate));
    props?.dialog?.data?.lastAccessFromDate &&
      setLastAccessFromDate(dayjs(props?.dialog?.data?.lastAccessFromDate));
    props?.dialog?.data?.lastAccessToDate &&
      setLastAccessToDate(dayjs(props?.dialog?.data?.lastAccessToDate));
    props?.dialog?.data?.state && setSelectedState(props?.dialog?.data?.state);
    props?.dialog?.data?.city && setSelectedCity(props?.dialog?.data?.city);
    props?.dialog?.data?.zipCode && setZipCode(props?.dialog?.data?.zipCode);
    props?.dialog?.data?.status &&
      setSelectedStatus(props?.dialog?.data?.status);
    props?.dialog?.data?.priority &&
      setSelectedPriority(props?.dialog?.data?.priority);
    props?.dialog?.data?.to && setSelectedMessageTo(props?.dialog?.data?.to);
    props?.dialog?.data?.from &&
      setSelectedMessageFrom(props?.dialog?.data?.from);
    props?.dialog?.data?.status &&
      setSelectedMessageStatus(props?.dialog?.data?.status);
  }, [props?.dialog?.data]);

  function handleOnClose() {
    setError('');
    setText('');
    setCreatedFromDate(null);
    setCreatedToDate(null);
    setLastAccessFromDate(null);
    setLastAccessToDate(null);
    setSelectedState('');
    setSelectedCity('');
    setZipCode('');
    setSelectedStore('');
    setSelectedStatus('');
    setSelectedPriority('');
    setSelectedMessageStatus('');
    setSelectedMessageFrom('');
    setSelectedMessageTo('');

    setSelectName('');
    setSelectSubject('');
    setSelectContent('');
    setCheckedPriority('normal');

    myContext.setConfirmDialog({ open: false });
  }

  function handleActivation(event: any, activation: boolean) {
    if (activation) {
      if (props?.dialog?.onYesClick) {
        props?.dialog?.onYesClick(event, activation);
        handleOnClose();
      }
    }
  }

  function handleSupplierFilterApply(event: any) {
    let filter = {
      ...(createdFromDate && {
        createdFromDate: formatDateTime(createdFromDate?.toISOString()),
      }),
      ...(createdToDate && {
        createdToDate: formatDateTime(createdToDate?.toISOString()),
      }),
      ...(lastAccessFromDate && {
        lastAccessFromDate: formatDateTime(lastAccessFromDate?.toISOString()),
      }),
      ...(lastAccessToDate && {
        lastAccessToDate: formatDateTime(lastAccessToDate?.toISOString()),
      }),
      ...(selectedState && { state: selectedState }),
      ...(selectedCity && { city: selectedCity }),
      ...(zipCode && { zipCode: zipCode }),
      ...(selectedStore && { stores: selectedStore }),
      ...(selectProducts && { products: selectProducts }),
      ...(selectedStatus && { status: selectedStatus }),
    };

    if (props?.dialog?.onYesClick) {
      props?.dialog?.onYesClick(event, filter);
      handleOnClose();
    }
  }

  function handleStoreFilterApply(event: any) {
    let filter = {
      ...(createdFromDate && {
        createdFromDate: formatDateTime(createdFromDate?.toISOString()),
      }),
      ...(createdToDate && {
        createdToDate: formatDateTime(createdToDate?.toISOString()),
      }),
      ...(lastAccessFromDate && {
        lastAccessFromDate: formatDateTime(lastAccessFromDate?.toISOString()),
      }),
      ...(lastAccessToDate && {
        lastAccessToDate: formatDateTime(lastAccessToDate?.toISOString()),
      }),
      ...(selectedState && { state: selectedState }),
      ...(selectedCity && { city: selectedCity }),
      ...(zipCode && { zipCode: zipCode }),
      ...(selectedStore && { stores: selectedStore }),
      ...(selectProducts && { products: selectProducts }),
      ...(selectedStatus && { status: selectedStatus }),
    };

    if (props?.dialog?.onYesClick) {
      props?.dialog?.onYesClick(event, filter);
      handleOnClose();
    }
  }

  function handleProductFilterApply(event: any) {
    let filter = {
      ...(createdFromDate && {
        createdFromDate: formatDateTime(createdFromDate?.toISOString()),
      }),
      ...(createdToDate && {
        createdToDate: formatDateTime(createdToDate?.toISOString()),
      }),
      ...(lastAccessFromDate && {
        lastAccessFromDate: formatDateTime(lastAccessFromDate?.toISOString()),
      }),
      ...(lastAccessToDate && {
        lastAccessToDate: formatDateTime(lastAccessToDate?.toISOString()),
      }),
      ...(selectedState && { state: selectedState.stateName }),
      ...(selectedCity && { city: selectedCity.cityName }),
      ...(zipCode && { zipCode: zipCode }),
      ...(selectedStore && { stores: selectedStore }),
      ...(selectProducts && { products: selectProducts }),
      ...(selectedStatus && { status: selectedStatus }),
    };

    if (props?.dialog?.onYesClick) {
      props?.dialog?.onYesClick(event, filter);
      handleOnClose();
    }
  }

  function handleMessageFilterApply(event: any) {
    let filter = {
      ...(createdFromDate && {
        createdFromDate: formatDateTime(createdFromDate?.toISOString()),
      }),
      ...(createdToDate && {
        createdToDate: formatDateTime(createdToDate?.toISOString()),
      }),
      ...(selectedPriority && { priority: selectedPriority }),
      ...(selectedMessageFrom && { from: selectedMessageFrom }),
      ...(selectedMessageTo && { to: selectedMessageTo }),
      ...(selectedMessageStatus && { status: selectedMessageStatus }),
    };

    if (props?.dialog?.onYesClick) {
      props?.dialog?.onYesClick(event, filter);
      handleOnClose();
    }
  }

  function handleOnYes(event: any) {
    switch (props.dialog?.type) {
      case 'deActivate':
        if (text === 'DEACTIVATE') {
          handleActivation(event, true);
        } else {
          setError(t('PLEASE_TYPE_DEACTIVATE'));
        }
        break;
      case 'reActivate':
        if (text === 'REACTIVATE') {
          handleActivation(event, true);
        } else {
          setError(t('PLEASE_TYPE_REACTIVATE'));
        }
        break;
      case 'language-Dialog':
        if (props?.dialog?.onYesClick) {
          props?.dialog?.onYesClick(event, selectedLanguage);
          handleOnClose();
        }
        break;
      case 'supplier-filter':
        handleSupplierFilterApply(event);
        break;
      case 'store-filter':
        handleStoreFilterApply(event);
        break;
      case 'product-filter':
        handleProductFilterApply(event);
        break;
      case 'message-filter':
        handleMessageFilterApply(event);
        break;
      case 'message-compose':
        if (
          !toAllSuppliers &&
          !validateField(dispatch, 'PLEASE_SELECT_NAME', selectedName)
        ) {
          return false;
        }
        if (!validateField(dispatch, 'PLEASE_ENTER_SUBJECT', selectSubject)) {
          return false;
        }
        if (
          !validateField(dispatch, 'PLEASE_ENTER_DESCRIPTION', selectContent)
        ) {
          return false;
        }
        if (props?.dialog?.onYesClick) {
          props?.dialog?.onYesClick(event, {
            selectedName,
            selectSubject,
            selectContent,
            checkedPriority,
            toAllSuppliers,
          });
          handleOnClose();
        }
        break;
      default:
        if (props?.dialog?.onYesClick) {
          props?.dialog?.onYesClick(event);
          handleOnClose();
        }
    }
  }

  function getLabelForNoButton(type: string | undefined): any {
    switch (type) {
      case 'deActivate':
      case 'reActivate':
      case 'message-filter':
      case 'supplier-filter':
      case 'store-filter':
      case 'product-filter':
      case 'message-compose':
      case 'language-Dialog':
        return 'CANCEL';
      case 'contact':
      case 'confirm-validation-message':
        return 'BACK';
      case 'filter':
        return 'RESET';
      default:
        return 'NO';
    }
  }

  function getLabelForYesButton(type: string | undefined): any {
    switch (type) {
      case 'deActivate':
        return 'DEACTIVE';
      case 'reActivate':
        return 'REACTIVE';
      case 'filter':
      case 'store-filter':
      case 'product-filter':
      case 'message-filter':
      case 'supplier-filter':
        return 'APPLY';
      case 'message-compose':
        return 'SEND';
      case 'language-Dialog':
        return 'SAVE';
      case 'forgotPassword':
        return 'OK';
      case 'confirm-validation-message':
        return 'CONTINUE';
      case 'rememberMe':
        return 'YES';
      default:
        return 'YES';
    }
  }

  function commonFilter() {
    return (
      <>
        <Grid item display={'flex'} columnGap={2}>
          <BakeasyFilterHeaderLabel message={t('CREATED_DATE')} />
        </Grid>
        <Grid item display={'flex'} columnGap={2}>
          <BakeasyDatePicker
            label={t('FROM')}
            value={createdFromDate}
            onChange={(value: any) => {
              setCreatedFromDate(value);
            }}
          />
          <BakeasyDatePicker
            label={t('TO')}
            value={createdToDate}
            onChange={(value: any) => {
              setCreatedToDate(value);
            }}
          />
        </Grid>
        <Grid item display={'flex'} columnGap={2} sx={{ marginTop: 2 }}>
          <BakeasyFilterHeaderLabel message={t('LAST_ACCESS_DATE')} />
        </Grid>
        <Grid item display={'flex'} columnGap={2}>
          <BakeasyDatePicker
            label={t('FROM')}
            value={lastAccessFromDate}
            onChange={(value: any) => {
              setLastAccessFromDate(value);
            }}
          />
          <BakeasyDatePicker
            label={t('TO')}
            value={lastAccessToDate}
            onChange={(value: any) => {
              setLastAccessToDate(value);
            }}
          />
        </Grid>
      </>
    );
  }

  function productFilter() {
    return (
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ marginTop: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <Dropdown.Status
              options={STATUS_ALL_ARRAY}
              value={selectedStatus}
              onChange={(event: any) => setSelectedStatus(event?.target?.value)}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  }

  function storeFilter() {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={4} mt={1}>
          <BakeasySelectAutoCompleteStates
            value={selectedState}
            options={_storeState?.value?.states}
            onChange={(newValue: any) => {
              if (typeof newValue === 'string' && newValue?.length > 0) {
                if (_storeState?.value?.states?.includes(newValue)) {
                  setSelectedState(newValue);
                }
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={4} mt={1}>
          <BakeasySelectAutoCompleteCities
            value={selectedCity}
            options={_storeState.value?.cities}
            onChange={(newValue: any) => {
              if (typeof newValue === 'string' && newValue?.length > 1) {
                if (_storeState?.value?.cities?.includes(newValue)) {
                  setSelectedCity(newValue);
                }
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
          <BakeasySelectAutoCompleteZipcode
            value={zipCode}
            options={_storeState?.value?.zipCodes}
            onChange={(newValue: any) => {
              if (_storeState?.value?.zipCodes?.includes(newValue)) {
                setZipCode(newValue);
              }
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
          <Dropdown.Status
            options={STATUS_ALL_ARRAY}
            value={selectedStatus}
            onChange={(event: any) => setSelectedStatus(event?.target?.value)}
          />
        </Grid>
      </Grid>
    );
  }

  function supplierFilter() {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={4} mt={2}>
          <BakeasySelectAutoCompleteStates
            value={selectedState}
            options={_supplierState?.value?.states}
            onChange={(newValue: any) => {
              if (typeof newValue === 'string' && newValue?.length > 0) {
                if (_supplierState?.value?.states?.includes(newValue)) {
                  setSelectedState(newValue);
                }
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={4} mt={2}>
          <BakeasySelectAutoCompleteCities
            value={selectedCity}
            options={_supplierState.value?.cities}
            onChange={(newValue: any) => {
              if (_supplierState?.value?.cities?.includes(newValue)) {
                setSelectedCity(newValue);
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={4} mt={1}>
          <BakeasySelectAutoCompleteZipcode
            value={zipCode}
            options={_supplierState?.value?.zipCodes}
            onChange={(newValue: any) => {
              if (_supplierState?.value?.zipCodes?.includes(newValue)) {
                setZipCode(newValue);
              }
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} xl={4} mt={1}>
          <Dropdown.Status
            options={STATUS_ALL_ARRAY}
            value={selectedStatus}
            onChange={(event: any) => setSelectedStatus(event?.target?.value)}
          />
        </Grid>
      </Grid>
    );
  }

  function messageFilter() {
    return (
      <>
        <Grid container spacing={2}>
          <Grid item>
            <BakeasyFilterHeaderLabel message={t('CREATED_DATE')} />
          </Grid>
          <Grid item container spacing={2}>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
              <BakeasyDatePicker
                label={t('FROM')}
                value={createdFromDate}
                onChange={(value: any) => {
                  setCreatedFromDate(value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
              <BakeasyDatePicker
                label={t('TO')}
                value={createdToDate}
                onChange={(value: any) => {
                  setCreatedToDate(value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
              <Dropdown.Priority
                value={selectedPriority}
                onChange={(event) => setSelectedPriority(event?.target?.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
              <Dropdown.MessageStatus
                options={MESSAGE_STATUS_ARRAY}
                value={selectedMessageStatus}
                onChange={(event) =>
                  setSelectedMessageStatus(event?.target?.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
              <BakeasySelectAutoCompleteMessageFrom
                disabled={false}
                value={selectedMessageFrom}
                options={_messagesState?.name}
                onChange={(newValue: any) => {
                  if (newValue === null) {
                    setSelectedMessageFrom(undefined);
                    dispatch(getNamesList({ page: 1, limit: 5 }));
                  }

                  if (typeof newValue === 'string' && newValue?.length > 2) {
                    if (
                      _messagesState?.name?.find(
                        (item: any) => item?.name === newValue
                      )
                    ) {
                      setSelectedMessageFrom(newValue);
                    } else {
                      dispatch(
                        getNamesList({ page: 1, limit: 5, search: newValue })
                      );
                    }
                  }

                  if (typeof newValue === 'string' && newValue?.length === 0) {
                    dispatch(getNamesList({ page: 1, limit: 5 }));
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
              <BakeasySelectAutoCompleteMessageTo
                disabled={false}
                value={selectedMessageTo}
                options={_messagesState?.name}
                onChange={(newValue: any) => {
                  if (newValue === null) {
                    setSelectedMessageTo(undefined);
                    dispatch(getNamesList({ page: 1, limit: 5 }));
                  }

                  if (typeof newValue === 'string' && newValue?.length > 2) {
                    if (
                      _messagesState?.name?.find(
                        (item: any) => item?.name === newValue
                      )
                    ) {
                      setSelectedMessageTo(newValue);
                    } else {
                      dispatch(
                        getNamesList({ page: 1, limit: 5, search: newValue })
                      );
                    }

                    if (
                      typeof newValue === 'string' &&
                      newValue?.length === 0
                    ) {
                      dispatch(getNamesList({ page: 1, limit: 5 }));
                    }
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }

  function messageCompose() {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <BakeasyAutoCompleteMessagesTo
            multiple={true}
            disabled={toAllSuppliers}
            options={_supplierState.value?.data}
            onChange={(newValue: any) => {
              if (typeof newValue === 'string' && newValue?.length > 2) {
                dispatch(
                  fetchSuppliers({ page: 1, limit: 10, search: newValue })
                );
              }
              if (typeof newValue === 'object') {
                setSelectName(newValue);
              }
            }}
          />
          <BakeasyCheckbox
            label={t('TO_ALL_SUPPLIERS')}
            value={toAllSuppliers}
            onClick={(event: any) => {
              setToAllSuppliers(event?.target?.checked);
              // if (event?.target?.checked) {
              //   setSelectName(undefined);
              // }
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField.Subject
            value={selectSubject}
            onChange={(event: any) => {
              setSelectSubject(event.target.value);
            }}
            placeHolder={t('ENTER_SUBJECT')}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField.Description
            value={selectContent}
            maxLength={500}
            required={true}
            onChange={(event: any) => {
              setSelectContent(event.target.value);
            }}
            placeHolder={t('ENTER_DESCRIPTION')}
          />
        </Grid>
        <Grid item xs={12}>
          <small style={{ color: GRAY_500 }}>
            {t('NOTE_YOU_CAN_ENTER_UP_TO_500_CHARACTERS')}
          </small>
        </Grid>
        <Grid item xs={12}>
          <BakeasyCheckbox
            label={t('SET_AS_HIGH_PRIORITY')}
            value={checkedPriority === 'urgent'}
            onClick={(event: any) => {
              if (event?.target?.checked) {
                setCheckedPriority('urgent');
              } else {
                setCheckedPriority('normal');
              }
            }}
          />
        </Grid>
      </Grid>
    );
  }

  function languageDialog() {
    return (
      <Grid item>
        <Dropdown.BakeasySelectLabelLanguage
          value={selectedLanguage}
          onChange={(e: any) => {
            setSelectedLanguage(e.target.value);
          }}
        />
      </Grid>
    );
  }

  function getContent(type: string | undefined, data: any): any {
    switch (type) {
      case 'contact':
        return (
          <Grid container>
            <Grid item xs={12} sm={6} md={6}>
              <Typography m={2}>
                <b>{t('FIRST_NAME')}</b>: {data?.firstName}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Typography m={2}>
                <b>{t('LAST_NAME')}</b>: {data?.lastName}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Typography m={2}>
                <b>{t('EMAIL_ID')}</b>: {data?.email}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <Typography m={2}>
                <b>{t('MOBILE')}</b>: {data?.mobile}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Typography m={2}>
                <b>{t('WORK')}</b>: {data?.work}
              </Typography>
            </Grid>
          </Grid>
        );
      case 'filter':
        return <>{commonFilter()}</>;
      case 'deActivate':
        return (
          <TextField.DeActivate
            value={text}
            onChange={function (
              event: React.ChangeEvent<HTMLInputElement>
            ): void {
              setText(event?.target.value);
            }}
            placeHolder={t('TYPE_DEACTIVATE_HERE')}
          />
        );
      case 'reActivate':
        return (
          <TextField.ReActivate
            value={text}
            onChange={function (
              event: React.ChangeEvent<HTMLInputElement>
            ): void {
              setText(event?.target.value);
            }}
            placeHolder={t('TYPE_REACTIVATE_HERE')}
          />
        );
      case 'store-filter':
        return (
          <>
            {commonFilter()}
            {storeFilter()}
          </>
        );
      case 'product-filter':
        return (
          <>
            {commonFilter()}
            {productFilter()}
          </>
        );
      case 'supplier-filter':
        return (
          <>
            {commonFilter()}
            {supplierFilter()}
          </>
        );
      case 'message-filter':
        return <>{messageFilter()}</>;
      case 'message-compose':
        return <>{messageCompose()}</>;
      case 'language-Dialog':
        return <>{languageDialog()}</>;
      default:
        return <></>;
    }
  }

  return (
    <React.Fragment>
      <BootstrapDialog
        open={props?.dialog?.open ? props?.dialog?.open : false}
        fullWidth={true}
        maxWidth={maxWidth}
      >
        <DialogTitle
          sx={{ margin: 0, padding: 2 }}
          style={{ fontWeight: 'bold' }}
          minWidth={200}
        >
          <Grid container sx={{ flexDirection: 'row', fontSize: '1.2rem' }}>
            {t(props?.dialog?.title as string)}
          </Grid>
        </DialogTitle>

        <IconButton
          onClick={handleOnClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
        <Divider />
        <DialogContent sx={{ margin: 0 }}>
          {props?.dialog?.message && props?.dialog?.message}
          {props?.dialog?.message && <Grid sx={{ margin: 1 }} />}
          {props?.dialog?.type &&
            getContent(props?.dialog?.type, props?.dialog?.data)}
          {error ?? error}
        </DialogContent>
        {props?.dialog?.type != 'contact' && <Divider />}
        <DialogActions sx={{ marginRight: 1, columnGap: 1 }}>
          {props?.dialog?.onNoClick && (
            <BakeasyButton
              size={'small'}
              label={t(getLabelForNoButton(props?.dialog?.type))}
              variant="outlined"
              onClick={handleOnClose}
            />
          )}

          {props?.dialog?.onYesClick && (
            <BakeasyButton
              size={'small'}
              label={t(getLabelForYesButton(props?.dialog?.type))}
              onClick={handleOnYes}
            />
          )}
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}
